import React from 'react';

import {
  CollegeVisitComparison,
  CollegeVisitComparisonSide,
} from '@backrs_ui/grow-ui/src/pages/CollegeVisitGuide/content';

import { Box, Chip, SxProps, Theme, Typography } from '@mui/material';

type ComparisonBodyProps = Readonly<{
  id: string;
  comparison: CollegeVisitComparison;
}>;

/** Two pill-labeled point lists side by side. */
export const ComparisonBody: React.FC<ComparisonBodyProps> = ({ id, comparison }) => (
  <Box id={id} sx={sidesSx}>
    <ComparisonSide side={comparison.left} />
    <ComparisonSide side={comparison.right} />
  </Box>
);

const ComparisonSide: React.FC<Readonly<{ side: CollegeVisitComparisonSide }>> = ({ side }) => (
  <Box sx={sideSx}>
    <Box sx={sideLabelRowSx}>
      <Chip variant="pill" size="sm" type="default" label={side.label} sx={sideLabelSx} />
    </Box>
    <Box component="ul" sx={listSx}>
      {side.points.map((point) => (
        <Typography component="li" key={point} variant="text-sm-regular" sx={pointSx}>
          {point}
        </Typography>
      ))}
    </Box>
  </Box>
);

const sidesSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: backrs.spacing['spacing-xl'],
  '@container (min-width: 720px)': {
    gridTemplateColumns: '1fr 1fr',
  },
});

const sideSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-sm'],
});

const sideLabelRowSx: SxProps<Theme> = {
  display: 'flex',
};

const sideLabelSx: SxProps<Theme> = ({ backrs }) => ({
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
  border: `1px solid ${backrs.colors['Colors/Foreground/fg-primary']}`,
  '& .MuiChip-label': {
    color: backrs.colors['Colors/Text/text-primary'],
  },
});

const listSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-sm'],
  m: 0,
  pl: backrs.spacing['spacing-xl'],
});

const pointSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
  '&::marker': {
    color: backrs.colors['Colors/Foreground/fg-quinary'],
    fontSize: '0.75em',
  },
});
